function createEventDef<TDetail = void>() {
  return <TType extends string>(type: TType) =>
    ({
      type: type,
      create: (detail?: TDetail) =>
        (detail === undefined
          ? new Event(type)
          : new CustomEvent(type, { detail })) as TDetail extends void
          ? Event
          : CustomEvent<TDetail>,
      dispatch: (detail?: TDetail) =>
        window.dispatchEvent(
          detail === undefined
            ? new Event(type)
            : new CustomEvent(type, { detail }),
        ),
    }) as const;
}

// No componentsRescan here: unlike the [data-component] div pattern,
// <rwc-*> custom elements auto-upgrade via connectedCallback as soon as
// they're inserted into the DOM (even dynamically), so there's nothing to
// manually rescan for.

export const BridgeEvents = {
  // All components ready event
  componentsReady: createEventDef<{
    count: number;
    components: Record<string, unknown>;
  }>()("react:components:ready"),

  // One component ready event
  componentReady: createEventDef<{ id: string; handle: unknown }>()(
    "react:component:ready",
  ),
};

declare global {
  interface WindowEventMap {
    [BridgeEvents.componentsReady.type]: ReturnType<
      typeof BridgeEvents.componentsReady.create
    >;
    [BridgeEvents.componentReady.type]: ReturnType<
      typeof BridgeEvents.componentReady.create
    >;
  }
}
